import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges, ChangeDetectorRef, inject } from '@angular/core';
import { formatDate } from '@angular/common';
import { Chart, ChartType, ChartDataset} from 'chart.js';
import { NWMBarChartSettings } from './NWMChartSettings';
import { tooltipType } from "app/components/NWMCharts/NWMCharts.module";
import { AppConfig } from "app/app.config";
import { APIService } from 'app/services/api.service';
import { AuthenticationService } from 'app/services/auth.service';
import { LoaderService } from "app/services/loader.service";
import {numOrNull} from "app/_helpers/num_or_null";
import { BaseChartDirective } from 'ng2-charts';
import { ChartTypeRegistry } from 'chart.js';

type apiDataType = {
  Inception: number;
  MEValuationDate: string;
  Year1: string;
  Year3: string;
  Year5: string;
  Year10: string;
};

@Component({
  selector: 'ARChart',
  templateUrl: './nwmchart.component.html',
  styleUrls: ['./nwmchart.component.scss'],
  imports: [BaseChartDirective]
})

export class ARChartComponent implements OnChanges {
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  private loaderService = inject(LoaderService);
  private config = inject(AppConfig);
  private ref = inject(ChangeDetectorRef);

  @Input() plan?: string;
  @Input() inception?: string;
  @Output() loaded : EventEmitter<boolean> = new EventEmitter();

  public dataLoaded = false;
  public chartData: ChartDataset<keyof ChartTypeRegistry, (number | null)[]>[] = [{data: [], backgroundColor: '#88A8A3'}];
  public chartLabels = ['1Yr', '3Yrs', '5Yrs', '10Yrs', ['Inception']];
  public chartType: ChartType = 'bar';
  public chartLegend = false;
  public tooltip: tooltipType = {visible: false, rows: []};
  public MEValuationDate?: string;
  public chartSettings: NWMBarChartSettings;
  public width = 500;
  public height = 250;

  constructor() {
    this.chartSettings = new NWMBarChartSettings();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (Object.prototype.hasOwnProperty.call(changes, 'inception')) {
      this.chartLabels[4] = ['Inception', formatDate(this.inception as string, 'MMM d, yyyy', 'en-US')];
    }

    if (Object.prototype.hasOwnProperty.call(changes, 'plan')) {
      this.dataLoaded = false;
      this.tooltip.visible = false;

      this.chartSettings.options.plugins = {
        tooltip:{
          enabled: false,
          external: (context)=> this.customTooltip(context.chart)
        }
      };

      this.loadChart();
    }
  }

  customTooltip(chart: Chart): void {
    const tooltipModel = chart.tooltip!;
    this.tooltip.visible = tooltipModel.opacity !== 0;
    if (tooltipModel.body) {
      if (tooltipModel.title[0].indexOf('Inception,') === 0) {
        tooltipModel.title[0] = tooltipModel.title[0] = 'Inception ';
      }
      this.tooltip.rows = [
        { key: tooltipModel.title + ': ', value: parseFloat(tooltipModel.body[0].lines[0]).toFixed(1) + '%' }
      ];
    }
    setTimeout(()=>{this.ref.detectChanges();});
  }

  loadChart() {
    this.loaderService.display(true, 'AICF');
    const reRg = this.auth.getCurrentReRg()!;
    const currentValuationDate = this.auth.getCurrentValuationDate();
    const planPath = this.api.getPlanPath(this.plan || '', reRg.IsPershing);

    this.api.get<apiDataType>(`${this.config.portfolio.portfolioSummaryAnnualizedReturnsUrl}/${reRg.ReRgId}/${currentValuationDate}/${planPath}`).subscribe(
      data => {
        this.loaded.emit(false);
        this.dataLoaded = false;
        this.chartData[0].data = [];

        if (data !== null && data !== undefined) {
          this.chartData[0].data = [
            ...[data.Year1, data.Year3, data.Year5, data.Year10].map(numOrNull),
            data.Inception
          ];
          this.MEValuationDate = data.MEValuationDate;
        }

        this.chartSettings.options.scales!['y']!.suggestedMax = this.chartSettings.getSuggestedMax(this.chartData[0].data as number[], .2);
        this.ref.detectChanges();
        this.dataLoaded = true;
        this.loaded.emit(true);
        this.loaderService.display(false, 'AICF');
      },
      () => {
        this.loaded.emit(false);
        this.loaderService.display(false, 'AICF');
      });
  }
}
